/**
 * Defines constant values for generating the Basic Illustration PDF
 */
export const constants = {
  PolicyFormNumber: 'ICC18WL',
  PolicyFormNumberForFlorida: 'WL-FL-2018',
  PolicyFormNumberForCalifornia: 'CA-WL‌-2018',
  PolicyFormNumberForDeleware: 'WL-DE-2018',
  PolicyFormNumberForNorthDakota: 'WL-ND-2018',
  PolicyFormNumberForSouthDakota: 'WL-SD-2018',
  PolicyFormNumberForNewYork: 'WL-NY-2020',

  //TODO : HL-6035 : https://massmutual.atlassian.net/browse/HL-6035
  TemporaryFlatExtraYears: '10',
  MECStatus: 'No',
  illustrationRowsOnFirstPage: 25,
  illustrationRowsOnOtherPages: 35,

  /**
   * Defines the Coverpath Basic Illustration Version
   */
  CPVersion: 'CP 1.0',

  /**
   * Defines productCode to WL term length
   */
  ProductSelection: {
    CPL100: '100',
    CPL100A: '100',
    CPL65: '65',
    CPL65A: '65',
    CPL10: '10',
    CPL10A: '10',
    CPL12: '12',
    CPL15: '15',
    CPL15A: '15',
    CPL20: '20',
    CPL20A: '20',
    MMTRADWL20: '20',
    MMTRADWL65: '65',
    MMTRADWL100: '100',
    CASTerm10: 'Convertible Term 10',
    CASTerm15: 'Convertible Term 15',
    CASTerm20: 'Convertible Term 20',
    CASTerm25: 'Convertible Term 25',
    CASTerm30: 'Convertible Term 30',
    CASTermECP10: 'Convertible Term 10 ECP',
    CASTermECP15: 'Convertible Term 15 ECP',
    CASTermECP20: 'Convertible Term 20 ECP',
    CASTermECP25: 'Convertible Term 25 ECP',
    CASTermECP30: 'Convertible Term 30 ECP',
    CASTerm1: 'Convertible Term ART',
    MMTRADTerm1: 'Vantage Term - ART',
    MMTRADTerm10: 'Vantage Term - 10',
    MMTRADTerm20: 'Vantage Term - 20',
    MMOPMTerm_2004b1: 'Term 20 Guaranteed',
    MMOPMTerm_2005b1: 'Term 20 Guaranteed',
    MMOPMTerm_2000b1: 'Term 20 Guaranteed-99',
    MMOPMTermAPT80_2000b1: 'Adjustable Premium Term 80',
    MMOPMTermAPT80_2006b1: 'Annually Renewable Term',
    MMTRADTermECP15: 'Vantage Term - 15 ECP',
    MMTRADTermECP20: 'Vantage Term - 20 ECP',
    MMTRADTermECP25: 'Vantage Term - 25 ECP',
    MMTRADTermECP30: 'Vantage Term - 30 ECP',
  },

  ProductNames: {
    CPL100: 'MassMutual Whole Life 100',
    CPL100A: 'MassMutual Whole Life 100',
    CPL65: 'MassMutual Whole Life 65',
    CPL65A: 'MassMutual Whole Life 65',
    CPL10: 'MassMutual Whole Life 10 Pay',
    CPL10A: 'MassMutual Whole Life 10 Pay',
    CPL12: 'MassMutual Whole Life 12 Pay',
    CPL15: 'MassMutual Whole Life 15 Pay',
    CPL15A: 'MassMutual Whole Life 15 Pay',
    CPL20: 'MassMutual Whole Life 20 Pay',
    CPL20A: 'MassMutual Whole Life 20 Pay',
  },

  PayableCopy: {
    CPL100: 'payable to Age 100',
    CPL100A: 'payable to Age 100',
    CPL65: 'payable to Age 65',
    CPL65A: 'payable to Age 65',
    CPL10: 'payable for 10 years',
    CPL10A: 'payable for 10 years',
    CPL12: 'payable for 12 years',
    CPL15: 'payable for 15 years',
    CPL15A: 'payable for 15 years',
    CPL20: 'payable for 20 years',
    CPL20A: 'payable for 20 years',
  },

  /**
   * The number of pages before The Tabular Values section.
   *
   * @remarks used for calculating the total number of pagess
   */
  PagesBeforeTabular: 6,
  SupplementalPagesBeforeTabular: 7,
  PagesInProductDisclosure: 5,
  TermInforcePagesBeforeTabular: 4,
  WholeInforcePagesBeforeTabular: 5,

  /**
   * Defines standard heights for the Basic Illustration header
   */
  HeaderHeight: {
    /**
     * Just the basic header and nothing else
     */
    Normal: '14mm',

    /**
     * Includes the height of the page title
     */
    Title: '22mm',
  },

  /**
   * Defines standard heights for the Basic Illustration footer
   */
  FooterHeight: {
    /**
     * Just the basic footer and nothing else
     */
    Normal: '15mm',

    /**
     * Includes the height of the Tabular Values disclaimer sections
     */
    Disclaimer: '45mm',
    SupplementalDisclaimer: '50mm',
  },

  InforceTermTitles: {
    NarrativeSummaryTitle: 'Narrative Summary',
    ClientInputSummaryTitle: 'Client Input Summary',
  },

  CirPayoutMethodTerm: {
    TwoPercent: '50 months (if 2% elected)',
    FourPercent: '25 months (if 4% elected)',
  },

  CirMonthlyIncreaseOption: {
    IncreasePool: 'Increase Benefit Pool',
    IncreasePeriod: 'Extend Benefit Period',
  },
  MMTRADWL100GenericPolicyFormNumber: 'WL-2007',
  MMTRADWL100PolicyFormNumbers: {
    AK: null, // Alaska
    AL: 'WL-AL-2007',
    AR: 'WL-AR-2007',
    AZ: 'WL-AZ-2007',
    CA: 'WL-CA-2007',
    CO: 'WL-CO-2007',
    CT: 'WL-CT-2007',
    DE: null, //Delaware
    DC: 'WL-DC-2007',
    FL: 'WL-FL-2007',
    GA: 'WL-GA-2007',
    HI: null, // Hawaii
    ID: 'WL-ID-2007',
    IL: 'WL-IL-2007',
    IN: 'WL-IN-2007',
    IA: 'WL-IA-2007',
    KS: 'WL-KS-2007',
    KY: 'WL-KY-2007',
    LA: 'WL-LA-2007',
    ME: 'WL-ME-2007',
    MD: 'WL-MD-2007',
    MA: 'WL-MA-2007',
    MI: 'WL-MI-2007',
    MN: 'WL-MN-2009',
    MS: 'WL-MS-2007',
    MO: 'WL-MO-2007',
    MT: null, // Montana
    NE: 'WL-NE-2007',
    NH: 'WL-NH-2007',
    NJ: 'WL-NJ-2007',
    NM: null, // New Mexico
    NV: null, // Nevada
    NY: 'WL-NY-2007',
    NC: 'WL-NC-2007',
    ND: 'WL-ND-2007',
    OH: null, // Ohio
    OK: 'WL-OK-2007',
    OR: 'WL-OR-2007',
    PA: 'WL-PA-2007',
    PR: 'WL-PR-2007',
    RI: 'WL-RI-2007',
    SC: 'WL-SC-2007',
    SD: 'WL-SD-2007',
    TN: 'WL-TN-2007',
    TX: 'WL-TX-2007',
    UT: 'WL-UT-2007',
    VT: 'WL-VT-2010',
    VA: 'WL-VA-2007',
    WA: 'WL-WA-2007',
    WI: 'WL-WI-2007',
    WV: 'WL-WV-2007',
    WY: null, // Wyoming
  },
};
